export enum Criteria
{
    at_least_eight_chars = 'minChar',
    at_least_one_lower_case_char = 'lowerCase',
    at_least_one_upper_case_char = 'upperCase',
    at_least_one_digit_char = 'digit',
    at_least_one_special_char = 'specialChar',
    at_custom_chars = 'customChars'
}
